import type { BoxProps } from '@packages/shared';
import { Box, Typography } from '@packages/shared';

export type SelectedInstallmentDisplayProps = BoxProps & {
  /**
   * the selected installment value
   */
  selectedInstallment: number;
  /**
   * the unit of the installment
   */
  unit: string;
};

/**
 * installment price atom
 *
 * atom to display the calculated installment price
 *
 * */
export const SelectedInstallmentDisplay = ({
  selectedInstallment,
  unit,
  ...rest
}: SelectedInstallmentDisplayProps) => (
  <Box {...rest} display="flex" flexDirection="column" alignItems="center">
    <Typography variant="h4" mb={0.5}>
      {unit}
    </Typography>
    <Typography variant="h1">{selectedInstallment}</Typography>
  </Box>
);
